// extracted by mini-css-extract-plugin
module.exports = {"statusEvent":"styles_statusEvent__UZ6cg","eventCard":"styles_eventCard__1q7sM","typeEvent":"styles_typeEvent__23R5c","webinar":"styles_webinar__UdTYL"};